export default __webpack_public_path__ + "static/media/more-ico.3f081514.svg";